import { render } from "./TrainingGroup.vue?vue&type=template&id=4797377e&scoped=true"
import script from "./TrainingGroup.vue?vue&type=script&lang=js"
export * from "./TrainingGroup.vue?vue&type=script&lang=js"

import "./TrainingGroup.vue?vue&type=style&index=0&id=4797377e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4797377e"

export default script